module.exports = __webpack_public_path__ + "static/media/repeatable-footer-on-preview.72e5f231.png";